// src/hooks/useSessionPersistence.js
import { useEffect } from 'react';

export const useSessionPersistence = (sessionType) => {
  useEffect(() => {
    // Force save current state every 5 seconds as backup
    const interval = setInterval(() => {
      const sessionTokens = localStorage.getItem(`${sessionType}_session_tokens_used`) || '0';
      const totalTokens = localStorage.getItem(`${sessionType}_total_spent_tokens`) || '0';
      const totalCost = localStorage.getItem(`${sessionType}_total_spent_cost`) || '0';
      
      console.log(`[${sessionType}] Session backup:`, {
        sessionTokens: Number(sessionTokens),
        totalTokens: Number(totalTokens),
        totalCost: Number(totalCost)
      });
    }, 5000);
    
    return () => clearInterval(interval);
  }, [sessionType]);
};